import styled from 'styled-components';

export const MenuButton = styled.button`
    all: unset;
    background-color: #f9fafb;
    height: 32px;
    width: 32px;
    border-radius: 5px;
    padding: 4px;
    display: grid;
    place-items: center;
    cursor: pointer;

    img {
        height: 26px;
        width: 26px;
    }
`;
